import React, { useContext } from 'react';
import { FuelButton, FuelIcon } from '@frete.com/fuel-react';
import { OpenRateDriver } from '@utils/companyEvaluating/companyEvaluating';
import useAmplitude from '@hooks/useAmplitude';
import AppContext from '@context';
import { JourneyListItemPropsInterface } from '../../JourneyListType';
import * as Styled from '../Desktop/JourneysAllTabDesktopStyles';

function ActionsButtons(props: JourneyListItemPropsInterface) {
  const {
    status,
    id,
    handlerModalDialogue,
    onClickEvaluatingJourneyList,
    isMobile,
  } = props;
  const { amplitudeEvent } = useAmplitude();
  const { dispatch } = useContext(AppContext);

  function handleAddRoute() {
    dispatch({
      type: 'ui_modalUpdatedAddress_set_show',
      payload: {
        isShow: true,
        flow: 'buttonListItem',
        journeyId: id,
      },
    });
    amplitudeEvent('journey_address_update_clicked', {
      source: 'button-inserir-rota-lista-item-viagens',
      journey_id: id,
    });
  }

  function statusDoneByTrucker() {
    return (
      <Styled.Wrapper>
        <FuelButton
          data-testid="list-denunciar-button"
          variant="tertiary"
          onClick={() => {
            OpenRateDriver(id);
            amplitudeEvent('company_dispute_request', {
              source: 'button-denunciar-lista-item-viagens',
            });
          }}
          size={isMobile ? 'medium' : 'small'}
          fullWidth={isMobile}
        >
          Denunciar
        </FuelButton>
        <FuelButton
          data-testid="list-confirmar-button"
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation();
            handlerModalDialogue?.(props);
          }}
          size={isMobile ? 'medium' : 'small'}
          fullWidth={isMobile}
        >
          Confirmar
        </FuelButton>
      </Styled.Wrapper>
    );
  }

  function statusPendingRoute() {
    return (
      <Styled.Wrapper>
        <FuelButton
          data-testid="list-inserir-rota-button"
          variant="secondary"
          onClick={(event) => {
            event.stopPropagation();
            handleAddRoute();
          }}
          size={isMobile ? 'medium' : 'small'}
          fullWidth={isMobile}
        >
          Inserir rota
        </FuelButton>
      </Styled.Wrapper>
    );
  }

  function statusDone() {
    return (
      <Styled.Wrapper>
        <FuelButton
          data-testid="list-avaliar-button"
          variant="secondary"
          onClick={() => onClickEvaluatingJourneyList?.(id)}
          size={isMobile ? 'medium' : 'small'}
          fullWidth={isMobile}
        >
          <Styled.WrapperButtonEvaluate>
            Avaliar
            <FuelIcon name="star-outlined" iconStyle="outlined" size="micro" />
          </Styled.WrapperButtonEvaluate>
        </FuelButton>
      </Styled.Wrapper>
    );
  }

  const mapJourneyStatusComponent = {
    done_by_trucker: statusDoneByTrucker(),
    pending_route: statusPendingRoute(),
    done: statusDone(),
  };
  return mapJourneyStatusComponent[status.slug] || null;
}
export default ActionsButtons;
